import { useParams } from 'react-router-dom'
import HeroSection from '@/components/sections/HeroSection'
import FeaturesSection from '@/components/sections/FeaturesSection'
import CTASection from '@/components/sections/CTASection'
import {
  investorsHero,
  investorsFeatures,
  investorsCTA,
} from '@content/pages/use-case-investors'
import { agentsHero, agentsFeatures, agentsCTA } from '@content/pages/use-case-agents'
import NotFoundPage from './NotFoundPage'

export default function UseCasePage() {
  const { slug } = useParams()

  // Map slug to content
  const contentMap: Record<string, any> = {
    investors: {
      hero: investorsHero,
      features: investorsFeatures,
      cta: investorsCTA,
    },
    agents: {
      hero: agentsHero,
      features: agentsFeatures,
      cta: agentsCTA,
    },
  }

  const content = slug ? contentMap[slug] : null

  if (!content) {
    return <NotFoundPage />
  }

  return (
    <>
      <HeroSection {...content.hero} />
      <FeaturesSection features={content.features} />
      <CTASection {...content.cta} />
    </>
  )
}
